import { Modal, Stack, Form, Button, Spinner } from "react-bootstrap";
import añadirOtros from "../functions/añadirOtros";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import firebaseApp from "../firebase/credenciales";
import { useState } from "react";
import { logBusinessAction } from "../services/AuditService";

const storage = getStorage(firebaseApp);

function ModalAñadir({
  isModalAñadir,
  setIsModalAñadir,
  actualizarEstadoProductos,
  usuario,
}) {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  async function añadirOtrosModal() {
    const ruc = usuario.ruc;
    const activo = true;
    const codigo = document.getElementById("codigo").value.trim();
    const nombre = document.getElementById("nombre").value.trim().toUpperCase();
    const descripcion = document.getElementById("descripcion").value.trim().toUpperCase();
    const rev = document.getElementById("rev").value.trim().toUpperCase();
    const orden = document.getElementById("orden").value.trim();
    const baseDatos = `reglamentos`;

    if (!file) {
      alert("Debes seleccionar un archivo PDF.");
      return;
    }

    setLoading(true);
    try {
      // Subir archivo a Storage
      const storageRef = ref(storage, `reglamentos/${ruc}/${file.name}`);
      await uploadBytes(storageRef, file);
      const url = await getDownloadURL(storageRef);

      // Guardar en Firestore
      const infoProducto = { activo, codigo, nombre, descripcion, rev, orden, url, ruc };
      await añadirOtros(infoProducto, usuario.email, baseDatos);

      // AUDITORÍA
      try {
        await logBusinessAction("SUBIDA_REGLAMENTO_POLITICA", "GestionDocumentos", {
          codigo: codigo,
          nombre: nombre,
          revision: rev
        }, usuario);
      } catch (e) {
        console.warn("No se pudo registrar la auditoría de subida", e);
      }

      actualizarEstadoProductos(baseDatos);
      setIsModalAñadir(false);
    } catch (err) {
      alert("Error al subir el documento");
      console.error(err);
    }
    setLoading(false);
  }

  return (
    <Modal show={isModalAñadir} onHide={() => setIsModalAñadir(false)}>
      <Modal.Header>
        <Modal.Title>Añadir Reglamento</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Stack>
            <Form.Control
              id="codigo"
              placeholder="Código"
              type="text"
              className="mb-1"
            />
            <Form.Control
              id="nombre"
              placeholder="Nombre"
              type="text"
              className="mb-1"
            />
            <Form.Control
              id="descripcion"
              placeholder="Descripción"
              type="text"
              className="mb-1"
            />
            <Form.Control
              id="rev"
              placeholder="Revisión"
              type="text"
              className="mb-1"
            />
            <Form.Control
              id="orden"
              placeholder="Orden"
              type="number"
              className="mb-1"
            />
            <Form.Label className="mt-2">Archivo PDF</Form.Label>
            <Form.Control
              type="file"
              accept="application/pdf"
              onChange={e => setFile(e.target.files[0])}
              className="mb-2"
            />
          </Stack>
        </Form>
        {loading && (
          <div className="text-center mt-2">
            <Spinner animation="border" size="sm" /> Subiendo...
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => setIsModalAñadir(false)} disabled={loading}>
          Cancelar
        </Button>
        <Button variant="primary" onClick={añadirOtrosModal} disabled={loading}>
          Añadir
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ModalAñadir;